'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.experimentsWrapper = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _windowWrapper = require('./windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

var _baseUtils = require('../utils/baseUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperimentsWrapper = function () {
  function ExperimentsWrapper() {
    (0, _classCallCheck3.default)(this, ExperimentsWrapper);

    this.getExperiment = this.getExperiment.bind(this);
    this.getExperiments = this.getExperiments.bind(this);
    this.setExperiments = this.setExperiments.bind(this);
    this._experiments = (0, _assign2.default)({}, (0, _extends3.default)({}, _windowWrapper2.default.petri));
    this.experimentsAreReady = (0, _keys2.default)(this._experiments) > 0;
    this.onExperimentReadyCb = [];
  }

  (0, _createClass3.default)(ExperimentsWrapper, [{
    key: 'setExperiments',
    value: function setExperiments(_experiments) {
      if (!_experiments) {
        return;
      }
      try {
        (0, _assign2.default)(this._experiments, (0, _extends3.default)({}, _experiments));
        if (_baseUtils.baseUtils.isDev()) {
          _windowWrapper2.default.petri = this._experiments;
        }
        this.triggerExperimentsReady();
        //resolve the promise
        this.experimentsAreReady = true;
      } catch (e) {
        console.error('Could not set experiments', e);
      }
    }
  }, {
    key: 'getExperiments',
    value: function getExperiments() {
      //todo - this is a temp fix for development
      if (_baseUtils.baseUtils.isDev()) {
        return (0, _extends3.default)({}, this._experiments, _windowWrapper2.default.petri);
      }
      return this._experiments;
    }
  }, {
    key: 'getExperiment',
    value: function getExperiment(experiment) {
      return this.experiments[experiment];
    }
  }, {
    key: 'triggerExperimentsReady',
    value: function triggerExperimentsReady() {
      var _this = this;

      try {
        this.onExperimentReadyCb.forEach(function (cb) {
          return cb(_this.experiments);
        });
      } catch (e) {
        console.error('Could not trigger experiments callback', e);
      }
    }
  }, {
    key: 'onExperimentsReady',
    value: function onExperimentsReady(callback) {
      if (typeof callback === 'function') {
        if (this.isReady) {
          callback(this.experiments);
        } else {
          this.onExperimentReadyCb.push(callback);
        }
      }
    }
  }, {
    key: 'experiments',
    get: function get() {
      return this.getExperiments();
    }
  }, {
    key: 'isReady',
    get: function get() {
      return this.experimentsAreReady || (0, _keys2.default)(this._experiments) > 0;
    }
  }]);
  return ExperimentsWrapper;
}();

var getExperimentsWrapper = function getExperimentsWrapper() {
  if (_baseUtils.baseUtils.isDev()) {
    if (!_windowWrapper2.default.proGalleryExperimentsWrapper) {
      var _experimentsWrapper = new ExperimentsWrapper();
      _windowWrapper2.default.proGalleryExperimentsWrapper = _experimentsWrapper;
    }
    return _windowWrapper2.default.proGalleryExperimentsWrapper;
  }
  return new ExperimentsWrapper();
};

var experimentsWrapper = getExperimentsWrapper();

exports.default = experimentsWrapper.getExperiment;
exports.experimentsWrapper = experimentsWrapper;